// const requireModule = require.context('.', true, /^((?!index).)*\.js$/)
// const modulesCache = {}

// requireModule.keys().forEach((fileName) => {
//   const moduleDefinition = requireModule(fileName)
//   const modulePath = fileName
//     .replace(/^\.\//, '')
//     .replace(/\.\w+$/, '')
//     .toUpperCase()
//   modulesCache[modulePath] = moduleDefinition.default
// })

// export default modulesCache
import { dingBeautyObj as dingBeautyBeautyObj } from "./dingBeauty_beauty";
import { dingBeautyObj as dingBeautyMassageObj } from "./dingBeauty_massage";
import { ipetBookingObj } from "./ipetBooking";
import { error } from "./error"
const defaultType = {
  'dingbeauty': 'beauty',
  'ipetbooking': 'pet'
}
const langRoute = function () {
  let i18n = localStorage.getItem('merchant.cached')
    ? JSON.parse(localStorage.getItem('merchant.cached')).i18n
    : defaultType[window.globalData.APP_TYPE]
    
  // console.log('origin i18n', i18n)
  if (!i18n) {
    i18n = defaultType[window.globalData.APP_TYPE]
  }
  // console.log('after i18n', i18n)

  const objMap = {
    massage: Object.assign({}, dingBeautyMassageObj, { 'ERROR': error }),
    beauty: Object.assign({}, dingBeautyBeautyObj, { 'ERROR': error }),
    pet: Object.assign({}, ipetBookingObj, { 'ERROR': error })
  }

  return objMap[i18n] || Object.assign({}, ipetBookingObj, { 'ERROR': error })
}


const decideLocal = function () {
  return langRoute() // 未來把這個打開就可以切換多語系
}
export default {
  ...decideLocal(),
}
